import React, { useCallback, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';

import Field from 'components/Field';
import NavBar from 'components/NavBar';
import styles from './SelectBatchModulePage.module.scss';
import SuperBatchSelect from 'components/SuperBatchSelect';

function SelectBatchModulePage() {
  const navigate = useNavigate();
  const [superBatch, setSuperBatch] = useState();

  const handleOnClick = useCallback(() => {
    navigate(String(superBatch?.id));
  }, [superBatch, navigate]);

  const handleOnChange = useCallback((newBatch) => {
    setSuperBatch(newBatch);
  }, []);

  return (
    <>
      <NavBar
        title="MODULE MANAGEMENT TOOL"
        id="module-management"
        homeUrl="/"
        className="p-xs"
      />
      <div className="p-l">
        <Field
          label="Search Batch"
          className="no-wrap"
        >
          <div className={styles.fieldContainer}>
            <div className={styles.field}>
              <SuperBatchSelect
                value={superBatch}
                onChange={handleOnChange}
                isMulti={false}
              />
            </div>
            <Tappable
              onClick={handleOnClick}
              className={classNames(
                'btn btn-primary btn-long',
                styles.tappable
              )}
            >
              Search
            </Tappable>
          </div>
        </Field>
        <Outlet />
      </div>
    </>
  );
}

export default SelectBatchModulePage;
